import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { SecondaryBody } from 'scy/text';
import Avatar from './Avatar';
import { BUTTON_CLASSES } from 'scy/buttons';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';

export default function WizardMain({
  customer,
  title,
  nextPath,
  buttonText,
  children
}) {
  const firstName = customer.first_name || '';

  return (
    <main className={styles.main}>
      <Avatar user={customer} />
      <SecondaryBody>{firstName || 'They'} sent you a gift!</SecondaryBody>
      <h1 className={styles.title}>{title}</h1>
      {children}
      {!!nextPath && (
        <Link
          to={nextPath}
          className={classnames(
            BUTTON_CLASSES.primaryRect,
            styles.cta,
            margin.tablet_bottom_md
          )}
        >
          {buttonText || 'Continue'}
        </Link>
      )}
    </main>
  );
}
